import React, {useEffect, useState} from 'react'
import {alertActions, regisActions} from '../../../store/actions'
import history from '../../../route/history'
import {connect} from 'react-redux'
import $ from 'jquery'
import TosModal from '../regis/modal/tosAgreeModal'
import PrivacyModal from '../regis/modal/privacyAgreeModal'
import * as common from "../../../assets/js/common";
import PccV4Simple from "../../../module/cert/Pcc/PccV4Simple";
import PccV4SimpleMobile from "../../../module/cert/Pcc/PccV4SimpleMobile";

const RegisSimpleTitle = (props) => {
    const [isLink, setIsLink] = useState(false)
    const [allCheck, setAllCheck] = useState(false)
    const [showTos, setShowTos] = useState(false)
    const [showPrivacy, setShowPrivacy] = useState(false)

    // 본인인증popup open 여부
    const [isPccOpen, setIsPccOpen] = useState(false)
    const [certResult, setCertResult] = useState(false)
    const enterMemberInfo = () => {
        setIsPccOpen(false)
    }

    const [state, setState] = useState({
        tosAgreYn: { title: '이용약관', require: true, agree: false, show: false },
        privacyAgreYn: { title: '(필수 수집)개인정보 수집 및 이용내역', require: true, agree: true, show: false },
        userInfo: props.location.state?.userInfo
    })

    useEffect(() => {
        setIsLink(true)
        console.log('연계간편기업회원')
    }, [])

    const [tosAgreYn, setTosAgreYn] = useState('N')
    const [privacyAgreYn, setPrivacyAgreYn] = useState('N')

    const [userInfo, setUserInfo] = useState({
        userSeCd: '02', // 법인관리회원

        memberName: state.userInfo?.memberName,
        mobileNo: state.userInfo?.mobileNo,
        groupRegistno: state.userInfo?.groupRegistno,
        groupName: state.userInfo?.groupName,
        bplcCd: state.userInfo?.bplcCd,
        email: state.userInfo?.email,
    })

    /*** 본인인증 관련 데이터 설정
     초기 상태 일 때 userInfo보다 나중에 아래 코드들이 호출될 경우,
     이전에 불러온 userInfo의 사용자 정보를 초기화시켜버림
     (본인인증 하기 전에는 값이 없기 때문에 사용자 정보를 ''로 초기화하므로
     userInfo가 사용자 정보로 세팅되기 전에 초기 호출되어야 함)
     ***/
    useEffect(() => {
        setUserInfo((userInfo) => ({
            ...userInfo,
            mobileCertDt: props.certDate,
        }))
    }, [props.certDate])

    useEffect(() => {
        setUserInfo((userInfo) => ({
            ...userInfo,
            certCi: props.certCi,
        }))
    }, [props.certCi])

    useEffect(() => {
        setUserInfo((userInfo) => ({
            ...userInfo,
            nativeYn: props.fgnGbn === '1' ? 'Y' : 'N', // 1-내국인, 2-외국인
        }))
    }, [props.fgnGbn])

    useEffect(() => {
        setUserInfo((userInfo) => ({
            ...userInfo,
            genderCd: props.sex,
        }))
    }, [props.sex])

    useEffect(() => {
        setUserInfo((userInfo) => ({
            ...userInfo,
            birthDay: props.birYMD,
        }))
    }, [props.birYMD])

    /** MOBILE_NO(휴대폰번호), CERT_CI(인증 CI값) 중복체크 */
    /*** 휴대폰 본인인증 ***/
    useEffect(() => {

            // 휴대폰번호, 인증CI값 중복체크 userSeCd: 01(개인회원)
            if (props.cellNo && props.certCi) {
                if(userInfo.mobileNo === props.cellNo && userInfo.memberName === props.certName) {
                    // MOBILE_NO(휴대폰번호), CERT_CI(인증 CI값) 중복체크
                    if (!props.checkMobileYn) {
                        props.error({message: '해당 휴대폰 번호로 가입된 사용자가 존재합니다.'})
                    } else {
                        history.replace({ pathname: '/regis/simpleInput', state: { userInfo } })
                    }
                } else {
                    props.error({
                        title: '확인',
                        message: '발급신청정보와 \n 본인인증정보(성명, 휴대폰번호)가 \n 일치하지 않습니다.',
                    })
                }
            }
    }, [props.checkMobileYn])

    useEffect(() => {
        setUserInfo((userInfo) => ({
            ...userInfo,
            tosAgreYn: tosAgreYn,
        }))

    }, [tosAgreYn])
    useEffect(() => {
        setUserInfo((userInfo) => ({
            ...userInfo,
            privacyAgreYn: privacyAgreYn
        }))

    }, [privacyAgreYn])


    /*** 전체동의 체크박스 Handler ***/
    const checkHandler = (e) => {
        const { id, checked } = e.target

        if (id === 'allChk' && $("#allChk").is(':checked')) {
            setAllCheck(checked)
            setState({
                ...state,
                tosAgreYn: { ...state.tosAgreYn, agree: checked },
                privacyAgreYn: { ...state.privacyAgreYn, agree: checked },
            })

            $("#tosAgreYn").removeClass("last")
            $("#privacyAgreYn").removeClass("last")
            $("#tosAgreYn").addClass("active")
            $("#privacyAgreYn").addClass("active")

            setTosAgreYn('Y')
            setPrivacyAgreYn('Y')

        } else {
            /*** 필수항목 전체 미동의 로직 추가 구현 필요(상태값)***/
            setAllCheck(checked)
            setState({
                ...state,
                tosAgreYn: { ...state.tosAgreYn, agree: checked },
                privacyAgreYn: { ...state.privacyAgreYn, agree: checked },
            })
            $("#tosAgreYn").removeClass("active")
            $("#privacyAgreYn").removeClass("active")
            $("#tosAgreYn").addClass("last")
            $("#privacyAgreYn").addClass("last")

            setTosAgreYn('N')
            setPrivacyAgreYn('N')
        }
        pccBtnActive()

    }

    /*** 이용약관 팝업 ***/
    const openTosAgreModal = () => {
        if($("#tosAgreYn").hasClass("active") === true) {
            setShowTos(false)
            setTosAgreYn('N')
            $("#tosAgreYn").removeClass("active")
        } else {
            $("#tosAgreYn").addClass("active")
            setShowTos(true)
            setTosAgreYn('Y')
        }
        pccBtnActive()
    }

    /*** 개인정보 수집 및 이용내역 ***/
    const openPrivacyAgreModal = () => {
        // if($("#privacyAgreYn").hasClass("active") === true) {
        //     setShowPrivacy(false)
        //     setPrivacyAgreYn('N')
        //     $("#privacyAgreYn").removeClass("active")
        // } else {
            $("#privacyAgreYn").addClass("active")
            setShowPrivacy(true)
            setPrivacyAgreYn('Y')
        // }
        // pccBtnActive()
    }

    const pccBtnActive = () => {
        // if($("#tosAgreYn").hasClass("active") === true && $("#privacyAgreYn").hasClass("active") === true && $("#optionalPrivacyAgreYn").hasClass("active") === true) {
        //     $("#pcc-btn").show()
        //     $("#no-pcc-btn").hide()
        //     setAllCheck(true)
        // } else if($("#allChk").is(":checked") && $("#tosAgreYn").hasClass("active") === true && $("#privacyAgreYn").hasClass("active") === true && $("#optionalPrivacyAgreYn").hasClass("active") === true) {
        //     $("#pcc-btn").show()
        //     $("#no-pcc-btn").hide()
        //     setAllCheck(true)
        // } else if($("#tosAgreYn").hasClass("active") === true && $("#privacyAgreYn").hasClass("active") === true) {
        //     $("#pcc-btn").show()
        //     $("#no-pcc-btn").hide()
        //     setAllCheck(false)
        // } else {
        //     $("#pcc-btn").hide()
        //     $("#no-pcc-btn").show()
        //     setAllCheck(false)
        // }
        if($("#tosAgreYn").hasClass("active") === true) {
            $("#pcc-btn").show()
            $("#no-pcc-btn").hide()
        } else {
            $("#pcc-btn").hide()
            $("#no-pcc-btn").show()
        }
    }

    /*** 다음단계 진행 이벤트 (/RegisSimpleInput) ***/
    const goNext = () => {
        // 이용약관 필수 항목 체크 여부 Validation Check
        history.replace({
                pathname: isLink ? '/regis/simpleInput' : '/',
                state: { userInfo },
            })
    }


    /*** 초기 화변 Return ***/
    return (
        <React.Fragment>
            <div className="wrapper">
                <div className="container">
                    <div className="top_bar"></div>
                    <h3 className="sub_tit">전자문서지갑 회원가입</h3>
                    <div className="sub_stit">
                        <strong>디지털 시험성적서를 온라인으로 발급</strong>받기 위한 <br /><span className="blue">전자문서지갑 회원가입</span>을 시작합니다.
                    </div>
                    <p><img src={require('../../../assets/images/sub/join_banner.png')} className="img-responsive img-center" alt="" /></p>

                    <div className="agree_wrap">
                        {/*<div className="all_agree">*/}
                        {/*    <div className="icheck">*/}
                        {/*        <input type="checkbox" name="allChk" id="allChk" onChange={checkHandler} checked={allCheck} value="" />*/}
                        {/*        <label htmlFor="allChk">전체 동의</label>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="one_agree">
                            <a href="#" id="tosAgreYn" className="link last" onClick={openTosAgreModal}>
                                [필수] <strong>서비스 이용약관</strong>
                            </a>
                            <a href="#" id="privacyAgreYn" className="link active" onClick={openPrivacyAgreModal}>
                                [필수] <strong>개인정보 수집 및 이용내역</strong>
                            </a>
                            <div>{showPrivacy && (<PrivacyModal isOpen={setShowPrivacy}/>)}</div>
                            <div>{showTos && (<TosModal isOpen={setShowTos}/>)}</div>
                        </div>

                        <div className="agree_caution">
                            개인정보 수집·이용 근거법령 : <br />
                            - 개인정보 보호법 제15조 제1항 제4호에 거하여 정보주체와 체결한 계약의 이행을 위해 필요한 경우<br />
                            - 정보주체와 체결한 계약을 이행하거나 계약을 체결하는 과정에서 정보주체의 요청에 따른 조치를 이행하기 위하여 필요한 경우
                        </div>
                        <div className="agree_caution">
                            본인확인 단계를 진행합니다. 본인확인에 필요한 절차를 진행합니다.
                        </div>
                    </div>
                </div>
            </div>
            <div className="btn_area">
                {/* active 제거 하시면 disable 색상으로 */}
                <button type="button" id="pcc-btn" className="btn btn-blue" style={{height: '60px', display: 'none'}}  onClick={() => setIsPccOpen(true)}>휴대폰 인증
                    {common.getDeviceType() !== 'MobileApp' ? (
                        <PccV4Simple bplcCd={userInfo.bplcCd} isPccOpen={isPccOpen} onChange={enterMemberInfo} callBack={setCertResult} />
                    ) : (
                        <PccV4SimpleMobile bplcCd={userInfo.bplcCd} isPccOpen={isPccOpen} onChange={enterMemberInfo} callBack={setCertResult} />
                    )}
                </button>
                {/* 휴대폰인증 절차 없이 테스트 진행하고 싶을 경우 아래 주석 해제*/}
                {/*<button type="button" id="pcc-btn" className="btn btn-blue" style={{height: '60px', display: 'none'}}  onClick={goNext}>휴대폰 인증</button>*/}
                <button type="button" id="no-pcc-btn"className="btn btn-gray active" style={{height: '60px'}}>휴대폰 인증</button>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        certResult: state?.certificate?.resultInfo?.result,
        cellNo: state?.certificate?.resultInfo?.cellNo,
        certName: state?.certificate?.resultInfo?.name,
        certCi: state?.certificate?.resultInfo?.ci1,
        certDate: state?.certificate?.resultInfo?.certDate,
        fgnGbn: state?.certificate?.resultInfo?.fgnGbn,
        sex: state?.certificate?.resultInfo?.sex,
        birYMD: state?.certificate?.resultInfo?.birYMD,
        user: state.regis,

        checkMobileYn: state.regis.checkMobileYn,
    }
}

const actionCreators = {
    success: alertActions.success,
    error: alertActions.error,
    checkMobile: regisActions.checkMobile,
}

export default connect(mapStateToProps, actionCreators)(RegisSimpleTitle)
